import { cloneDeep } from 'lodash';
import UserGridOptions from '@/services/User/UserGridOptions';
import * as types from '../mutation-types';

// state
export const state = UserGridOptions.getGridOptionNamesState();

// mutations
export const mutations = {
  [types.SAVE_GRID_OPTIONS_SUCCESS](state, { name, config, sort, filter }) {
    state[name].grid = {
      state: config,
      sort,
      filter,
    };
  },
  [types.SAVE_GRID_OPTIONS_FAILURE](state) {},
  [types.SAVING_GRID_OPTIONS](state) {},
  [types.FETCHING_GRID_OPTIONS](state) {},
  [types.FETCH_GRID_OPTIONS_SUCCESS](state, config) {
    Object.entries(config).forEach(([name, grid]) => {
      state[name].grid.state = grid.state;
      state[name].grid.sort = grid.sort;
      state[name].grid.filter = grid.filter;
    });
  },
  [types.FETCH_GRID_OPTIONS_FAILURE](state) {},
  [types.RESET_GRID_OPTIONS](state, name) {
    state[name].grid.state = {};
    state[name].grid.sort = {};
    state[name].grid.filter = {};
  }
};

// actions
export const actions = {

  /**
   * @param commit
   * @param status
   * @param config
   * @returns {Promise<void>}
   */
  async saveGridOptions({ commit, rootGetters }, {
    name, state, sort, filter,
  }) {
    commit(types.SAVING_GRID_OPTIONS, name);
    const clientId = rootGetters.userClientId;
    const params = {  name, state, sort, filter, clientId };
    try {
      await UserGridOptions.saveState(params);
      params.config = state;
      commit(types.SAVE_GRID_OPTIONS_SUCCESS, params);
    } catch (e) {
      commit(types.SAVE_GRID_OPTIONS_FAILURE);
    }
  },

  /**
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchGridOptions({ commit, rootGetters }) {
    commit(types.FETCHING_GRID_OPTIONS);

    try {
      const response = await UserGridOptions.getState(rootGetters.userClientId);
      commit(types.FETCH_GRID_OPTIONS_SUCCESS, response.data.data);
    } catch (e) {
      commit(types.FETCH_GRID_OPTIONS_FAILURE);
    }
  },

  resetLocalStorageGridOptions({ commit }, name) {
    commit(types.RESET_GRID_OPTIONS, name);
  }
};

// getters
export const getters = {
  gridSort: state => (name) => {
    if (!state[name] || !state[name].grid) {
      return null;
    }

    return cloneDeep(state[name].grid.sort);
  },
  gridFilter: state => (name) => {
    if (!state[name] || !state[name].grid) {
      return null;
    }

    return cloneDeep(state[name].grid.filter);
  },
  gridState: state => (name) => {
    if (!state[name] || !state[name].grid) {
      return null;
    }

    return cloneDeep(state[name].grid.state);
  },
};
